import React, {useEffect, useState} from "react";
import {AppComponent} from "../App";
import {Settings} from "./Settings";
import {Tabs} from "../utils/Tabs";
import {Auth} from "./Auth";
import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAuth, signInWithEmailAndPassword, signOut} from "firebase/auth";
import {storage} from "../utils/localstorage";
import LogoutIcon from '@mui/icons-material/Logout';
import css from "../css/admin.module.css";
import {Campaigns} from "./Campaigns";
import {Invoices} from "./Invoices";
import {Users} from "./Users";
import {Problems} from "./Problems";
import {Logs} from "./Logs";

const firebaseConfig = {
    apiKey: "AIzaSyC50e5UW-tJIyeONgoqssA8sP6UF0pRsi0",
    authDomain: "mathem-org.firebaseapp.com",
    databaseURL: "https://mathem-org-default-rtdb.firebaseio.com",
    projectId: "mathem-org",
    storageBucket: "mathem-org.firebasestorage.app",
    messagingSenderId: "184288288824",
    appId: "1:184288288824:web:fa104790ebe36d3a9b46cd",
    measurementId: "G-DWZBEXRMV5"
};
const app = initializeApp(firebaseConfig)
const auth = getAuth(app);
export const db = getFirestore();

export const Admin = () => {
    const [forbidden, setForbidden] = useState(false);

    const signInFirebaseUser = (email, password) => signInWithEmailAndPassword(auth, email, password);

    const onLogout = async () => {
        storage("adminKey", false);
        await signOut(auth);
        document.location = document.location;
    }

    useEffect(() => {
        if (!storage("adminKey")) {
            setForbidden(true);
            signOut(auth);
        }
    }, []);

    AppComponent.adminForbidden = setForbidden;

    return forbidden ? <Auth signInFirebaseUser={signInFirebaseUser}/> : (
        <>
            <LogoutIcon onClick={onLogout} className={css.logout}/>
            <Tabs items={[
                {title: "Campaigns", component: <Campaigns/>},
                {title: "Logs", component: <Logs/>},
                {title: "Settings", component: <Settings/>},
                {title: "Invoices", component: <Invoices/>},
                {title: "Users", component: <Users/>},
                {title: "Problems", component: <Problems/>},
            ]}/>
        </>
    )
}
